import { uaLimitedReleasesListConstants } from "../_redux-constants";
import { uaLimitedReleasesListService } from "../../_services";

function getUALimitedReleasesList(queryParams) {
  function getUALimitedReleasesListLoad() {
    return {
      type: uaLimitedReleasesListConstants.UA_LIMITED_RELEASES_LIST_LOADING,
    };
  }
  function getUALimitedReleasesListSuccess(data) {
    return {
      type: uaLimitedReleasesListConstants.UA_LIMITED_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function getUALimitedReleasesListFailure(error) {
    return {
      type: uaLimitedReleasesListConstants.UA_LIMITED_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getUALimitedReleasesListLoad());
    return uaLimitedReleasesListService
      .getUALimitedReleasesList(queryParams)
      .then(
        (data) => {
          dispatch(getUALimitedReleasesListSuccess(data));
        },
        (error) => {
          dispatch(getUALimitedReleasesListFailure(error?.toString()));
        }
      );
  };
}

export const uaLimitedReleasesListActions = {
  getUALimitedReleasesList,
};
